import React from 'react';

import { IconAmenity } from './Rm3Icons';

const MAX_CHIPS = 5;

/** First five carrier amenities (catalog `amenities[].name`, else `room_group_details.perks`), untranslated. */
function Rm3AmenityChips({ amenities }) {
    if (!amenities.length) {
        return null;
    }
    return (
        <div className="rm3-amenities" data-testid="rm3-room-amenities">
            {amenities.slice(0, MAX_CHIPS).map((name, index) => (
                <span className="rm3-amenities__chip" key={`${index}-${name}`}>
                    <IconAmenity name={name} />
                    <bdi>{name}</bdi>
                </span>
            ))}
        </div>
    );
}

export default Rm3AmenityChips;
